"use client";

import { useMessages } from "@/providers/langProvider";
import type { Translation } from "./getTranslation";

/**
 * The active locale's dictionary, for client components.
 *
 * Reads the dictionary the server resolved for this request instead of picking
 * one out of a bundled map — which is what used to force BOTH dictionaries into
 * an every-page chunk. See the note in `getTranslation.ts`.
 *
 * Deliberately still synchronous and still returns the whole dictionary, so the
 * hundreds of existing call sites are unchanged.
 */
export const useTranslation = (): Translation => useMessages();
